import React, { useEffect } from "react";
import NavBar from "./components/Navbar";
import House from "./components/House";

function App() {
  useEffect(() => {
  }, [])

  return (
    <div>
      <NavBar />
      <House />
    </div>
  );
}

export default App;